import React from 'react';
import PropTypes from 'prop-types';
import SystemNotification from './SystemNotification';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Cookies from 'js-cookie';
import { loadApiData, loadExternalData } from '../util/ApiUtil';
import { getCurrentRuleSetName } from '../util/UrlUtil';

export default class SystemNotifications extends React.Component {
  static propTypes = {
    adminifiUrl: PropTypes.string,
    animate: PropTypes.bool,
    authToken: PropTypes.string,
    messageRenderDelay: PropTypes.number,
    messages: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
      })
    ),
    userId: PropTypes.string.isRequired,
  };

  static defaultProps = {
    animate: true,
    messageRenderDelay: 250,
  };

  constructor(props) {
    super(props);
    this.state = {
      messages: [],
    };
  }

  async componentDidMount() {
    const { animate, messageRenderDelay, userId, adminifiUrl, authToken, messages } = this.props;
    const messagesFromApi = await this.getUserSytemNotifications(
      userId,
      adminifiUrl,
      authToken,
      getCurrentRuleSetName()
    );
    let allMessages = Array.isArray(messages) ? messages.concat(messagesFromApi) : messagesFromApi;
    const messagesToDisplay = allMessages.filter(message => !this.closedMessageIds.includes(message.id));

    if (messagesToDisplay.length) {
      if (animate) {
        setTimeout(() => {
          const addMessagesInterval = setInterval(() => {
            const messages = this.state.messages.slice(0);
            messages.push(messagesToDisplay.shift());
            this.setState({ messages });
            if (!messagesToDisplay.length) {
              clearInterval(addMessagesInterval);
            }
          }, messageRenderDelay);
        }, messageRenderDelay);
      } else {
        this.setState({ messages: messagesToDisplay });
      }
    }
  }

  getUserSytemNotifications = async (userId, adminifiUrl, authToken, ruleSetName) => {
    const url = `${adminifiUrl || ''}/api/data/user_system_messages/${userId}.json${
      ruleSetName ? `?rule_set_name=${ruleSetName}` : ''
    }`;

    let messages;
    try {
      if (authToken) {
        messages = await loadExternalData(url, authToken);
      } else {
        messages = await loadApiData(url);
      }
    } catch (e) {
      //if the BE errors, that's ok, we just won't show any messages
      messages = [];
    }

    return messages.filter(message => message.view_locations.includes('login'));
  };

  getStorageKey = userId => `${userId}-closed-system-messages`;

  get closedMessageIds() {
    const messages = Cookies.getJSON(this.getStorageKey(this.props.userId), { domain: this.domain });
    return messages || [];
  }

  set closedMessageIds(messageIds) {
    Cookies.set(this.getStorageKey(this.props.userId), messageIds, { domain: this.domain });
  }

  get domain() {
    const domainArray = window.location.host.split(':')[0].split('.');
    domainArray.shift();
    return domainArray.join('.');
  }

  onClose = messageId => {
    const messages = this.state.messages.filter(message => message.id !== messageId);
    this.setState({ messages }, () => {
      const closedMessageIds = this.closedMessageIds;
      closedMessageIds.push(messageId);
      this.closedMessageIds = closedMessageIds;
    });
  };

  render() {
    const { messages } = this.state;
    const transitionTimeout = this.props.animate ? 1000 : 0;

    return (
      <div className="system-notifications">
        <TransitionGroup className="system-transition-group">
          {messages.map(message => {
            return (
              <CSSTransition classNames="notification" timeout={transitionTimeout} key={message.id}>
                <SystemNotification {...message} onClose={this.onClose} />
              </CSSTransition>
            );
          })}
        </TransitionGroup>
      </div>
    );
  }
}
